export function isObjEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) return false;
  }

  return true;
}

export const isValidateToken = (error) => { 
  return error === "Error validating token"; 
}

export const info_data = [
    {
      data: [
        { className: "text-center", text: 1 },
        { className: "text-left", text: "PayNet MasterScore" },
        { className: "text-center background-green-1", text: 200, background: "rgb(75.17647058823529,175.94117647058823,92.29411764705883)" },
        { className: "text-center", text: 200 }
      ]
    },
    {
      data: [
        { className: "text-center", text: 2 },
        { className: "text-left", text: "FICO Guarantor 1" },
        { className: "text-center background-green-1", text: 165 },
        { className: "text-center", text: 165 }
      ]
    },
    {
      data: [
        { className: "text-center", text: 3 },
        { className: "text-left", text: "FICO Guarantor 2" },
        { className: "text-center background-green-2", text: 90 },
        { className: "text-center", text: 140 }
      ]
    },
    {
      data: [
        { className: "text-center", text: 4 },
        { className: "text-left", text: "Time in Business" },
        { className: "text-center background-red", text: 0 },
        { className: "text-center", text: 110 }
      ]
    },
    {
      data: [
        { className: "text-center", text: 5 },
        { className: "text-left", text: "Inquiries Last 12 months" },
        { className: "text-center background-green-1", text: 90 },
        { className: "text-center", text: 90 }
      ]
    },
    {
      data: [
        { className: "text-center",text: 6 },
        { className: "text-left", text: "Recent Avg APD" },
        { className: "text-center background-red", text: 0 },
        { className: "text-center", text: 80 }
      ]
    },
    {
      data: [
        { className: "text-center", text: 7 },
        { className: "text-left", text: "Number of Guarantors" },
        { className: "text-center background-red", text: 0 },
        { className: "text-center", text: 80 }
      ]
    },
    {
      data: [
        { className: "text-center", text: 8 },
        { className: "text-left", text: "Number of Paid Accounts" },
        { className: "text-center background-yellow", text: 20 },
        { className: "text-center", text: 65 }
      ]
    },
    {
      data: [
        { className: "text-center", text: 9 },
        { className: "text-left", text: "Maximum Monthly Payment" },
        { className: "text-center background-green-1", text: 40 },
        { className: "text-center", text: 40 }
      ]
    },
    {
      data: [
        { className: "text-center", text: 10 },
        { className: "text-left", text: "State" },
        { className: "text-center background-yellow", text: 15 },
        { className: "text-center", text: 30 }
      ]
    }
  ]

export const decision_data = [
    {
      data: [
        { className: "text-center", text: 1 },
        { className: "text-center", text: "Strong Consumer Score" },
        { className: "text-center background-yellow", text: "Prevent Auto Decline" }
      ]
    },
    {
      data: [
        { className: "text-center", text: 2 },
        { className: "text-center", text: "Strong Commercial Score" },
        { className: "text-center background-yellow", text: "Prevent Auto Decline" }
      ]
    },
    {
      data: [
        { className: "text-center", text: 3 },
        { className: "text-center", text: "Short time in business" },
        { className: "text-center background-yellow", text: "Prevent Auto Approve" }
      ]
    }
]
  
export const data_chart = [
    {
        categories: ["<=600", "601-640", "641-670", "671-700", ">=700"],
        values: [0, 0, 0, 0, 1],
        color: "rgb(12, 168, 82)"
    },
    {
        categories: ["<=580", "581-625", "626-685", "686-740", ">=740"],
        values: [0, 0, 0, 0, 1],
        color: "rgb(12, 168, 82)"
    },
    {
        categories: ["<=625", "626-690", "691-710", ">=711"],
        values: [0, 0, 1, 0],
        color: "rgb(90, 192, 43)"
    },
    {
        categories: ["<=12", "13-24", "25-60", ">=61"],
        values: [1, 0, 0, 0],
        color: "rgb(231, 17, 17)"
    },
    {
        categories: [">5", "<=5"],
        values: [0, 1],
        color: "rgb(12, 168, 82)"
    },
    {
        categories: [">10", "4-10", "<=3"],
        values: [1, 0, 0],
        color: "rgb(231, 17, 17)"
    },
    {
        categories: ["<=2", ">2"],
        values: [1, 0],
        color: "rgb(231, 17, 17)"
    },
    {
        categories: ["<=1", "2-5", ">5"],
        values: [0, 1, 0],
        color: "#e0d648"
    },
    {
        categories: ["<=$1500", ">$1500"],
        values: [0, 1],
        color: "rgb(12, 168, 82)"
    },
    {
        categories: ["High Risk Dtates", "Medium Risk States", "Low Risk States"],
        values: [0, 1, 0],
        color: "#e0d648"
    },
]

export const dataTable = [
  {name: "Airi Satou", email: "airi@gmail.com" },
  {name: "Angelica Ramos", email: "angelica@gmail.com"},
  {name: "Ashton Cox", email: "ashton@gmail.com"},
  {name: "Bradley Greer", email: "bradley@outlook.com"},
  {name: "Brenden Wagner", email: "breden@gmail.com"},
  {name: "Brielle Williamson", email: "bri@gmail.com"},
  {name: "Caesar Vance", email: "caesar@hotmail.com"},
  {name: "Cedric Kelly", email: "cedirc@gmail.com"},
  {name: "Charde Marshall", email: "chard@gmail.com"},
  {name: "Colleen Hurst", email: "collen@gmail.com"},
  // ["Dai Rios", "Personnel Lead", "Edinburgh", "35"],
  // ["Doris Wilder", "Sales Assistant", "Sidney", "23"],
  // ["Fiona Green", "Chief Operating Officer (COO)", "San Francisco", "48"],
  // ["Garrett Winters", "Accountant", "Tokyo", "63"],
  // ["Gavin Cortez", "Team Leader", "San Francisco", "22"],
  // ["Gavin Joyce", "Developer", "Edinburgh", "42"],
  // ["Gloria Little", "Systems Administrator", "New York", "59"],
  // ["Haley Kennedy", "Senior Marketing Designer", "London", "43"],
  // ["Herrod Chandler", "Sales Assistant", "San Francisco", "59"],
  // ["Hope Fuentes", "Secretary", "San Francisco", "41"],
  // ["Howard Hatfield", "Office Manager", "San Francisco", "51"],
  // ["Jackson Bradshaw", "Director", "New York", "65"],
  // ["Jena Gaines", "Office Manager", "London", "30"],
  // ["Jenette Caldwell", "Development Lead", "New York", "30"],
  // ["Jennifer Chang", "Regional Director", "Singapore", "28"],
  // ["Martena Mccray", "Post-Sales support", "Edinburgh", "46"],
  // ["Michael Silva", "Marketing Designer", "London", "66"],
  // ["Michelle House", "Integration Specialist", "Sidney", "37"],
  // ["Olivia Liang", "Support Engineer", "Singapore", "64"],
  // ["Paul Byrd", "Chief Financial Officer (CFO)", "New York", "64"],
  // ["Prescott Bartlett", "Technical Author", "London", "27"],
  // ["Quinn Flynn", "Support Lead", "Edinburgh", "22"],
  // ["Rhona Davidson", "Integration Specialist", "Tokyo", "55"],
  // ["Shou Itou", "Regional Marketing", "Tokyo", "20"],
  // ["Sonya Frost", "Software Engineer", "Edinburgh", "23"],
  // ["Suki Burks", "Developer", "London", "53"],
  // ["Tatyana Fitzpatrick", "Regional Director", "London", "19"],
  // ["Timothy Mooney", "Office Manager", "London", "37"],
  // ["Unity Butler", "Marketing Designer", "San Francisco", "47"],
  // ["Vivian Harrell", "Financial Controller", "San Francisco", "62"],
  // ["Yuri Berry", "Chief Marketing Officer (CMO)", "New York", "40"],
  // ["Tiger Nixon", "System Architect", "Edinburgh", "61"]
];